import styled from 'styled-components';

/**
 * The headline and its figures. Plain flex wrapping does the responsive part
 * (no container query: styled-components 5 drops @container): the headline
 * grows to push the figures to the right while they fit beside it, and the
 * figures, one unit as wide as all of them in a row, wrap under it as a
 * whole once they do not - never one figure per line beside the headline.
 * The right margin keeps them clear of the arrow in the corner.
 */
export const CardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 32px;
  margin-right: 36px;
`;

/** Icon, title and value; grows to fill whatever the figures leave. */
export const Headline = styled.div`
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
`;

/**
 * As wide as the figures in one row, never wider than the card: on a phone,
 * where even their own row is too narrow, they wrap among themselves.
 */
export const InlineStats = styled.div`
  flex: 0 0 auto;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
`;

/**
 * The card's round icon: a solid colour behind a white glyph, the way the
 * services show their logos; no background for a logo that is its own
 * circle.
 */
export const IconTile = styled.div<{ $background?: string }>`
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $background }) => $background ?? 'transparent'};

  svg {
    width: ${({ $background }) => ($background ? '20px' : '40px')};
    height: auto;
  }
`;

/** The title and, beside it, the card's tag. */
export const TitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/** A quiet tinted tag beside the title: "54% margin". */
export const CardTag = styled.span<{ $color: string; $background: string }>`
  padding: 3px 8px;
  border-radius: 10px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
`;

/** A figure's label, after the dot that ties it to its bar segment. */
export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StatDot = styled.span<{ $color: string }>`
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;
